import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77fe8ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow flex flex-col space-y-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl text-gray-600 dark:text-gray-300 font-medium" }, " Collect achievements and get rewarded! ", -1))
const _hoisted_3 = {
  class: "grid grid-flow-row grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3",
  style: {"grid-auto-rows":"1fr"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center p-3 border-2 border-gray-300 dark:border-gray-700 border-dashed rounded-md" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-lg text-gray-400 text-center" }, " New achievements coming soon… ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BadgeWidget = _resolveComponent("BadgeWidget")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.achievedBadges, (b, i) => {
        return (_openBlock(), _createBlock(_component_BadgeWidget, {
          key: i,
          badge: b
        }, null, 8, ["badge"]))
      }), 128)),
      _hoisted_4
    ])
  ]))
}